import { HTMLAttributes, ReactElement, ReactNode } from 'react';

import { DefaultLayout } from '@/components/layout/Layout';
import { LeftItemType, LogoLinkType, RightItemType } from '@/lib/types/layout';

const LEFT_ITEM_TYPES: LeftItemType[] = ['back', 'close', 'primaryLogo', 'blackLogo', 'whiteLogo', 'grayLogo'];
const RIGHT_ITEM_TYPES: RightItemType[] = ['exitTextButton', 'inquiryTextButton', 'inquiryIconButton', 'shareTextButton', 'moreIconButton'];

export const isLeftItemType = (value: unknown): value is LeftItemType => LEFT_ITEM_TYPES.includes(value as LeftItemType);

export const isRightItemType = (value: unknown): value is RightItemType => RIGHT_ITEM_TYPES.includes(value as RightItemType);

const toRightItems = (value: unknown): RightItemType[] | undefined => {
  if (Array.isArray(value)) {
    const items = (value as unknown[]).filter(isRightItemType);
    return items.length > 0 ? items : undefined;
  }
  return isRightItemType(value) ? [value] : undefined;
};

export const createErrorPageLayout =
  (
    options: {
      isNoticeVisible?: boolean;
      logoLinkType?: LogoLinkType;
      inquiryLink?: string;
      headerBackgroundColor?: string;
      mainClassName?: HTMLAttributes<HTMLDivElement>['className'];
      footerContent?: ReactNode;
    } = {},
    topNavLeftButton?: string,
    topNavRightButton?: string | string[]
  ) =>
  (page: ReactElement, pageProps: Record<string, unknown>) => {
    const { leftButton, rightButton } = pageProps;

    const leftItem =
      leftButton != null ? (isLeftItemType(leftButton) ? leftButton : undefined) : isLeftItemType(topNavLeftButton) ? topNavLeftButton : undefined;
    const rightItems = rightButton != null ? toRightItems(rightButton) : toRightItems(topNavRightButton);

    return (
      <DefaultLayout leftItem={leftItem} rightItems={rightItems} {...options}>
        {page}
      </DefaultLayout>
    );
  };

export const parseTopNavButtonQuery = (
  query: Record<string, string | string[] | undefined>
): { leftButton: string | string[] | null; rightButton: string | string[] | null } => ({
  leftButton: query['nav-left-button'] ?? null,
  rightButton: query['nav-right-button'] ?? null
});
